module.exports = __webpack_public_path__ + "img/m1.a7569c01.png";